import { AxiosResponse } from "axios";
import { http } from "../api-http";
import { List } from "../models/list.model";
import { Hyperlocal } from "../models/hyperlocal.model";

export class HyperlocalService {

    private static  _instance: HyperlocalService | null = null;

    static getInstance(): HyperlocalService {
        if(!HyperlocalService._instance) {
            HyperlocalService._instance = new HyperlocalService();
        }
        return HyperlocalService._instance;
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {
    }


    getAvailableHyperlocal(): Promise<Hyperlocal[]> {
        return http.get<List<Hyperlocal>>('/api/hyper-local/locations').then((response: AxiosResponse<List<Hyperlocal>>) => {
            return response.data.data;
        })
    }
}